// extracted by mini-css-extract-plugin
export var bodySections = "_89-8";
export var gray = "_89-7";
export var green = "_89-4";
export var iconContainer = "_89-9";
export var iconWidgetContainer = "_89-1";
export var phoneIcon = "_89-2";
export var red = "_89-5";
export var statusDot = "_89-3";
export var widgetContainer = "_89-0";
export var yellow = "_89-6";